import { useState } from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    Stack,
    TextField,
    Tooltip,
} from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

function CredencialGeradaDialog({ open, credencial, onClose }) {
    const [copiado, setCopiado] = useState('');

    if (!credencial) return null;

    async function copiar(valor, campo) {
        try {
            await navigator.clipboard.writeText(valor || '');
            setCopiado(campo);
        } catch (error) {
            setCopiado('erro');
        }
    }

    const copiarTudo = () =>
        copiar(`clientId=${credencial.clientId}\nclientSecret=${credencial.clientSecret}`, 'credenciais');

    const copiarButton = (valor, campo) => (
        <InputAdornment position="end">
            <Tooltip title="Copiar">
                <IconButton edge="end" onClick={() => copiar(valor, campo)}>
                    <ContentCopy />
                </IconButton>
            </Tooltip>
        </InputAdornment>
    );

    return (
        <Dialog open={open} maxWidth="md" fullWidth disableEscapeKeyDown>
            <DialogTitle>Credencial da integração PDV</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <Alert severity="warning">
                        Guarde o clientSecret agora. Depois que esta janela for fechada, ele não poderá ser consultado
                        novamente. Para obter outro, será necessário rotacionar a credencial.
                    </Alert>

                    <TextField
                        label="clientId"
                        value={credencial.clientId || ''}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                            endAdornment: copiarButton(credencial.clientId, 'clientId'),
                        }}
                    />

                    <TextField
                        label="clientSecret"
                        value={credencial.clientSecret || ''}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                            endAdornment: copiarButton(credencial.clientSecret, 'clientSecret'),
                        }}
                    />

                    {copiado && (
                        <Alert severity={copiado === 'erro' ? 'error' : 'success'}>
                            {copiado === 'erro'
                                ? 'Não foi possível copiar automaticamente. Selecione o conteúdo do campo.'
                                : `${copiado} copiado.`}
                        </Alert>
                    )}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" startIcon={<ContentCopy />} onClick={copiarTudo}>
                    Copiar tudo
                </Button>
                <Button variant="contained" color="success" onClick={onClose}>
                    Já guardei as credenciais
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CredencialGeradaDialog;
